import React, { useCallback, useRef } from 'react'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { View } from 'react-native'
import { ListWithInfiniteScroll, Spinner, SearchByMovementNumber, LoadCard } from '../../../../components'
import Filters from '../Filters'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import * as historyActions from '../../../../redux/offers/historyActions'
import { historySelector } from '../../../../redux/offers/historySelector'
import { openLoadDetails } from '../../../../redux/loadDetails/loadDetailsActions'
import { setPayload } from '../../helpers'
ReactGA.pageview('/main/offers/history')
const History = () => {
  const { offers, noMore, loadMore, loadPage, filters } = useSelector(historySelector)
  const { isTablet } = usePlatforms()
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const modalRef = useRef(null)

  useFocusEffect(
    useCallback(() => {
      return () => { dispatch(historyActions.setFilters({ movementNumber: '' })) }
    }, [dispatch])
  )

  const getOffers = useCallback(() => {
    const body = setPayload(filters)
    const { offset } = filters

    dispatch(historyActions.getHistoryOffers({ offset, body }))
  }, [dispatch, filters])

  useFocusEffect(getOffers)

  const handleLoadMore = useCallback(() => {
    if (noMore || loadMore) return
    dispatch(historyActions.loadMore(1))
  }, [dispatch, loadMore, noMore])

  const handleDetail = useCallback(load => {
    const module = 'offers-history'
    if (isTablet) {
      dispatch(openLoadDetails({
        module,
        load
      }))
    } else {
      navigation.navigate('load-details', {
        module,
        movementNumber: load.movementNumber
      })
    }
  }, [navigation, dispatch, isTablet])

  const clearFilters = useCallback(() => {
    dispatch(historyActions.setFilters())
  }, [dispatch])

  const handleSearch = useCallback((payload) => {
    dispatch(historyActions.setFilters({
      ...payload,
      manageStatus: [],
      movementNumber: ''
    }))
  }, [dispatch])

  const hanldeMovementNumber = useCallback(movementNumber => {
    dispatch(historyActions.searchByMovementNumber(movementNumber))
  }, [dispatch])

  const onOpen = () => {
    const { current = null } = modalRef
    current && current.open()
  }

  const onClose = () => {
    const { current = null } = modalRef
    current && current.close()
  }

  return (
    <View style={{ flex: 1, paddingTop: isTablet ? 10 : 20, paddingHorizontal: 10 }}>
      {!isTablet && (
        <View style={{ marginBottom: 20 }}>
          <SearchByMovementNumber
            initialValue={filters.movementNumber}
            openFilters={onOpen}
            handleSearch={hanldeMovementNumber}
            handleClearFilters={clearFilters}
            applyFilters={setPayload(filters)}
          />
        </View>)}
      <Filters
        initialValues={filters}
        onClose={onClose}
        handleSearch={handleSearch}
        handleClearFilters={clearFilters}
        modalRef={modalRef}
        handleSearchOrderNumber={hanldeMovementNumber}
      />
      <View style={{ flex: 1 }} testID='offersHistoryListContainer' accessibilityLabel='offersHistoryListContainer'>
        {loadPage ? (
          <Spinner />
        ) : (
          <ListWithInfiniteScroll
            data={offers || []}
            component={LoadCard}
            noMore={noMore}
            handleLoadMore={handleLoadMore}
            loading={loadMore}
            cardProps={{
              handleDetail: handleDetail,
              isHistory: true,
              hasLabel: true
            }}
            noDataMessage='No history found'
            testID='offersHistoryList'
          />)}
      </View>
    </View>
  )
}

export default History
